import Customer from "./Customer";
import Carrier from "./Carrier";
import OrderItem from "./OrderItem";
import OrderLocation from "./OrderLocation";
import OrderContact from "./OrderContact";
import OrderStatusLog from "./OrderStatusLog";
import BaseModel from "./BaseModel";
import OrderNote from "./OrderNote";
import Employee from "./Employee";
import Contact from "./Contact";
import Location from "./Location";
import Estimate from "./Estimate";
import PriceListItem from "./PriceListItem";

export default class PriceList extends BaseModel {

	static entity = 'price_lists';
	static route = 'price-lists';
	static plural = 'price_lists';
	static singular = 'price_list';

	static fields () {
		return {
			id: this.attr(null),
			name: this.attr(null),
			tier: this.attr(null),
			email: this.attr(null),
			active_start: this.attr(null),
			active_end: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			price_list_items: this.hasMany(PriceListItem, 'price_list_id', 'id'),
			estimates: this.hasMany(Estimate, 'price_list_id', 'id')
		}
	}

}
